import { WEBHOST_URL } from './constants'
import { mergeSearch } from './index'

export const trimFileLink = url => {
    if (!url) return url

    const privateIndex = url.indexOf('/private/')
    const publicIndex = url.indexOf('/public/')
    
    return privateIndex >= 0 || publicIndex >= 0 ?
        url.substring(privateIndex > 0 ? privateIndex : publicIndex) :
        url
}
/** Gets the file name from the end of a url */
export const getFileName = url => url.substring(url.lastIndexOf('/') + 1)

/** Formats a link to a pdf */
export const formatPdfLink = (search, id, url, page = undefined) => ({
    pathname: '/pdf',
    search: mergeSearch(search, `id=${id}&url=${'/' + url}&page=${page || ''}`)
})

/** Formats a link to a managed file */
export const formatFileLink = url => {
    let trimmedLink = trimFileLink(url)
    if (trimmedLink && !trimmedLink.startsWith('/'))
        trimmedLink = '/' + trimmedLink

    return trimmedLink ? WEBHOST_URL + trimmedLink : undefined
}

/** Formats a byte number to is appropriate unit (KB, MB, GM, etc.) 
 *  Pulled from: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript#answer-18650828 */
export const formatBytes = (bytes, decimals) => {
    if(bytes === 0) // Note to self: This used to be just '==' instead of '==='. might cause problems - rrogers
        return '0 Bytes'
        
    const k = 1024,
        dm = decimals <= 0 ? 0 : decimals || 2,
        i = Math.floor(Math.log(bytes) / Math.log(k)),
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}